/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Mulai_H1Inputs */

const en_simple_mulai_h1 = /** @type {(inputs: Simple_Mulai_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have the idea. Not the app.`)
};

const id_simple_mulai_h1 = /** @type {(inputs: Simple_Mulai_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punya ide. Belum punya aplikasinya.`)
};

/**
* | output |
* | --- |
* | "You have the idea. Not the app." |
*
* @param {Simple_Mulai_H1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_mulai_h1 = /** @type {((inputs?: Simple_Mulai_H1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Mulai_H1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_mulai_h1(inputs)
	return en_simple_mulai_h1(inputs)
});